/** localStorage keys for last computed "Fit" row counts (one per v2 list page). */
export const FIT_PER_PAGE_STORAGE_KEY = {
    customers: "customers_per_page",
    manifests: "manifests_per_page",
    orders: "orders_per_page",
}

const MIN_ROWS = 1
const MAX_ROWS = 500

function clampFitPerPage(n) {
    if (!Number.isInteger(n) || n <= 0) {
        return null
    }
    return Math.min(MAX_ROWS, Math.max(MIN_ROWS, n))
}

/**
 * Read a cached fit row count from localStorage, or null if missing/invalid.
 * @param {string} key
 * @returns {number | null}
 */
export function readCachedFitPerPage(key) {
    if (typeof localStorage === "undefined") {
        return null
    }
    try {
        const raw = localStorage.getItem(key)
        if (raw == null || raw === "") {
            return null
        }
        const parsed = Number.parseInt(raw, 10)
        return clampFitPerPage(parsed)
    } catch {
        return null
    }
}

/**
 * Persist fit row count for future sessions and page loads.
 * @param {string} key
 * @param {number} value
 */
export function writeCachedFitPerPage(key, value) {
    if (typeof localStorage === "undefined") {
        return
    }
    const n = clampFitPerPage(value)
    if (n == null) {
        return
    }
    try {
        localStorage.setItem(key, String(n))
    } catch {
        // Quota, private mode, or storage disabled
    }
}
